import { render } from "./transformation-projects.vue?vue&type=template&id=334b9d10&scoped=true"
import script from "./transformation-projects.vue?vue&type=script&lang=js"
export * from "./transformation-projects.vue?vue&type=script&lang=js"

import "./transformation-projects.vue?vue&type=style&index=0&id=334b9d10&lang=scss"
import "./transformation-projects.vue?vue&type=style&index=1&id=334b9d10&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334b9d10"]])

export default __exports__